import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import { ToastContainer } from "react-toastify";
import POS from "layouts/pos";
const App = () => {
  return (
    <>
    <Routes>
      <Route path="auth/*" element={<AuthLayout />} />
      <Route path="admin/*" element={<AdminLayout />} />
      <Route path="rtl/*" element={<RtlLayout />} />
      <Route path="pos/*" element={<POS />} />
      <Route path="/" element={<Navigate to="/admin" replace />} />
    </Routes>
    <ToastContainer />
    </>
  );
};

export default App;


// import React from "react";
// import { Routes, Route, Navigate, Outlet } from "react-router-dom";
// import RtlLayout from "layouts/rtl";
// import AdminLayout from "layouts/admin";
// import AuthLayout from "layouts/auth";
// import { ToastContainer } from "react-toastify";
// import { useFirebaseNotification } from "hooks/useFirebaseNotification";

// // Dummy auth check function (replace with actual logic)
// const isAuthenticated = () => {
//   return !!localStorage.getItem("token"); // or check for user info
// };

// // Protected route wrapper
// const PrivateRoute = () => {
//   return isAuthenticated() ? <Outlet /> : <Navigate to="/auth/sign-in" replace />;
// };

// const App = () => {
//   useFirebaseNotification();
//   return (
//     <>
//       <Routes>
//         {/* Auth Routes */}
//         <Route path="auth/*" element={<AuthLayout />} />

//         {/* Protected Routes */}
//         <Route element={<PrivateRoute />}>
//           <Route path="admin/*" element={<AdminLayout />} />
//           <Route path="rtl/*" element={<RtlLayout />} />
//         </Route>

//         {/* Default Redirect to Signin */}
//         <Route path="/" element={<Navigate to="/auth/sign-in" replace />} />
//       </Routes>

//       <ToastContainer />
//     </>
//   );
// };

// export default App;

